{
  "title": "Payment",
  "subtitle": "Complete your trademark registration payment",
  "summary": {
    "title": "Order Summary",
    "countries": "Countries Selected",
    "classes": "Nice Classes",
    "subtotal": "Subtotal",
    "governmentFees": "Government Fees",
    "serviceFee": "Service Fee",
    "total": "Total",
    "taxNote": "Prices include applicable taxes"
  },
  "methods": {
    "title": "Payment Method",
    "card": "Credit/Debit Card",
    "cardNumber": "Card Number",
    "expiry": "Expiry Date",
    "cvc": "CVC",
    "nameOnCard": "Name on Card",
    "secure": "Secure Payment",
    "stripeTitle": "Stripe Secure Checkout",
    "stripeDesc": "Your payment is processed securely through Stripe. We never store your credit card information.",
    "ssl": "256-bit SSL encryption",
    "pci": "PCI DSS compliant",
    "cards": "Accepts all major credit cards"
  },
  "status": {
    "processing": "Processing payment...",
    "success": "Payment Successful!",
    "failed": "Payment Failed",
    "tryAgain": "Please try again or use a different payment method.",
    "pending": "Payment Pending",
    "refunded": "Refunded"
  },
  "confirmation": {
    "title": "Payment Confirmed",
    "thankYou": "Thank you for your payment!",
    "receiptSent": "A receipt has been sent to {{email}}",
    "nextSteps": "Next Steps",
    "applicationSubmitted": "Your trademark application has been submitted for processing.",
    "viewStatus": "View Filing Status",
    "downloadReceipt": "Download Receipt"
  },
  "buttons": {
    "pay": "Pay {{amount}}",
    "payNow": "Pay Now",
    "reviewOrder": "Review Order",
    "proceedToPayment": "Proceed to Payment",
    "payAmount": "Pay ${{amount}} - Proceed to Secure Checkout",
    "agreeTerms": "I agree to the",
    "terms": "Terms of Service",
    "and": "and",
    "privacy": "Privacy Policy"
  }
}
